import { ComparatorEnum } from '../../../models/interface/comparator.enum';
import { PermissionPaymentsOption } from '../keys/permissionPayments.enum';
import { PermissionBaseType } from '../models/permissionBaseType.enum';
import { PermissionOption } from '../models/permissionOption.interface';

export const permissionPayments: PermissionOption[] = [
  {
    code: 'P316',
    option: PermissionPaymentsOption.PAYMENTS_COMMON_LOGIN,
    permissions: ['payments.common.login'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P318',
    option: PermissionPaymentsOption.PAYMENTS_METHOD_RECHARGE_LIST,
    permissions: ['payments.method.rechargeList'],
  },
  {
    code: 'P319',
    option: PermissionPaymentsOption.PAYMENTS_METHOD_RECHARGE_ACCOUNT,
    permissions: ['payments.method.rechargeAccount'],
  },
  {
    code: 'P321',
    option: PermissionPaymentsOption.PAYMENTS_METHOD_SHOW_BALANCE,
    permissions: ['payments.method.showBalance'],
  },
  {
    code: 'P320',
    option: PermissionPaymentsOption.PAYMENTS_METHOD_SHOW_SUMMARY,
    permissions: ['payments.method.showSummary'],
    comparator: ComparatorEnum.STARTS_WITH,
  },
  {
    code: 'P431',
    option: PermissionPaymentsOption.PAYMENTS_METHOD_SHOW_ITEM_MPAY,
    permissions: ['domi.method.showItemMpay'],
  },
  {
    type: PermissionBaseType.FLAG,
    code: 'FXXX',
    option: PermissionPaymentsOption.PAYMENTS_FLAG_LIST_ADD_CREDIT_CARD_CO,
    permissions: ['payments_flag_list_add_credit_card_co'],
    country: 'CO',
  },
  {
    type: PermissionBaseType.FLAG,
    code: 'FXXX',
    option: PermissionPaymentsOption.PAYMENTS_FLAG_LIST_ADD_CREDIT_CARD_MX,
    permissions: ['payments_flag_list_add_credit_card_mx'],
    country: 'MX',
  },
  {
    type: PermissionBaseType.FLAG,
    code: 'FXXX',
    option: PermissionPaymentsOption.PAYMENTS_FLAG_PSE_CO,
    permissions: ['payments_flag_pse_co'],
    country: 'CO',
  },
  {
    type: PermissionBaseType.FLAG,
    code: 'FXXX',
    option: PermissionPaymentsOption.PAYMENTS_FLAG_TRANSFER_MX,
    permissions: ['payments_flag_transfer_mx'],
    country: 'MX',
  },
];
